<template>
  <div
    style="max-width: 500px"
    class="mx-auto"
  >
    <b-card class="mb-1">
      <h4>Feedback</h4>
      <p class="mb-0">
        Umpan balik positif dan negatif dari jawaban MIA.
      </p>
    </b-card>

    <b-card
      v-for="(item, index) in items"
      :key="`feedback-${item.id}`"
      class="chat-content mb-50"
      :class="{ 'border-top': index > 0 }"
    >
      <b-row>
        <b-col>
          <b-form-row class="align-items-center mb-1 pb-1 border-bottom">
            <b-col cols="auto">
              <b-avatar
                :src="item.user ? linkStaging(item.user.photo_url, 50, 50) : null"
              />
            </b-col>
            <b-col>
              <div class="font-weight-bold">
                {{ item.user ? item.user.name : 'Akun tidak tersedia' }}
              </div>
              <small>{{ formatSelectDate(item.created_at, ['date','month','year','time']) }}</small>
            </b-col>

            <b-col cols="auto">
              <b-badge
                v-if="item.type === 'positive'"
                class="text-uppercase d-flex align-items-center"
                variant="success"
              >
                <feather-icon
                  icon="ThumbsUpIcon"
                  class="mr-25 mb-25"
                />
                Positif
              </b-badge>
              <b-badge
                v-else-if="item.type === 'negative'"
                class="text-uppercase d-flex align-items-center"
                variant="danger"
              >
                <feather-icon
                  icon="ThumbsDownIcon"
                  class="mr-25 mt-25"
                />
                Negatif
              </b-badge>
            </b-col>
          </b-form-row>

          <div
            class="rounded-lg rounded-top-right-0 border px-1 py-50 shadow mt-75 w-75 text-white ml-auto bg-gradient-primary"
          >
            <div
              v-if="item.chat.is_auto_answered"
              class="text-nowrap opacity-half s-12 mb-25"
            >
              Auto Reply
            </div>
            <div
              class="pb-25"
              v-html="item.chat.message"
            />
          </div>

          <div class="rounded-lg rounded-top-left-0 border px-1 py-50 shadow mt-75 w-75">
            <div
              v-if="item.chat.is_auto_answered"
              class="text-nowrap opacity-half s-12 mb-25"
            >
              Feedback
            </div>
            <div class="pb-25">
              {{ item.message }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <div
      v-if="meta"
      class="text-center py-2"
    >
      <b-button
        v-if="meta.current_page
          !== meta.last_page"
        variant="primary"
        :disabled="isLoading"
        class="d-flex align-items-center mx-auto"
        @click="loadData"
      >
        <b-spinner
          v-if="isLoading"
          small
          label="Spinning"
          class="mr-50"
        />
        Lihat lebih banyak
      </b-button>
      <span
        v-else
        class="text-muted"
      >Menampilkan seluruh feedback</span>
    </div>
    <div
      v-else-if="isLoading"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        label="Spinning"
        class="mx-auto mt-2"
      />
    </div>
  </div>
</template>

<script>
import {
  BBadge,
  BCard,
  BButton,
  BAvatar,
  BFormRow,
  BRow,
  BCol, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
    BBadge,
    BCard,
    BButton,
    BAvatar,
    BFormRow,
    BRow,
    BCol,
  },
  data() {
    return {
      isLoading: false,
      items: [],
      meta: null,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.isLoading = true

      return this.$http.get('v1/admin/chat-feedbacks', {
        params: {
          limit: 5,
          page: this.meta ? this.meta.current_page + 1 : 1,
        },
      })
        .then(response => {
          if (!this.meta) {
            this.items = []
          }

          this.items.push(...response.data.data)
          this.meta = response.data.meta
        })
        .catch(() => null)
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
.rounded-top-right-0 {
  border-top-right-radius: 0 !important;
}
.rounded-top-left-0 {
  border-top-left-radius: 0 !important;
}

.chat-content ::v-deep a {
  color: white;
  font-weight: 700;
  text-decoration: underline;
}
</style>
